import Cookies from 'universal-cookie';

export const getCsrfTokenKeyByEnv = () => {
  const appEnv = (process.env.REACT_APP_ENV || '').toLowerCase();

  if (appEnv === 'qa') return 'QA-X-CSRF-TOKEN';
  if (appEnv === 'uat') return 'UAT-X-CSRF-TOKEN';
  if (appEnv === 'dev') return 'DEV-X-CSRF-TOKEN';

  // Keep prod and all other environments on the default key.
  return 'X-CSRF-TOKEN';
};

export const getCsrfTokenFromCookies = () => {
  const csrfTokenKey = getCsrfTokenKeyByEnv();
  const cookies = new Cookies();
  const csrfToken = cookies.get(csrfTokenKey);

  return { csrfTokenKey, csrfToken };
};
